/**
 * 3D Pack Toggle — shared animation logic
 * Exposes window.initPackToggle(viewer, btn) for reuse.
 */
(function () {
    'use strict';

    function initPackToggle(viewer, btn) {
        var isAnimating = false;
        var isOpen = false;

        function playOnceHold(primary, secondary, tetriary) {
            if (isAnimating) return;
            isAnimating = true;
            viewer.pause();
            viewer.autoplay = false;
            viewer.currentTime = 0;
            viewer.animationName = primary;

            requestAnimationFrame(function () {
                if (secondary) {
                    viewer.appendAnimation(secondary, { repetitions: 1, pauseWhenFinished: true, time: 0 });
                }
                if (tetriary) {
                    viewer.appendAnimation(tetriary, { repetitions: 1, pauseWhenFinished: true, time: 0 });
                }
                viewer.play({ animationName: primary, repetitions: 1, pauseWhenFinished: true, time: 0 });
            });
        }

        viewer.addEventListener('finished', function () {
            isAnimating = false;
        });

        btn.addEventListener('click', function () {
            if (isAnimating) return;
            if (isOpen) {
                playOnceHold('close_pack', 'inside_close', 'Cigar_close');
                btn.textContent = 'Otwórz paczkę';
            } else {
                playOnceHold('open_pack', 'inside_open', 'Cigar_open');
                btn.textContent = 'Zamknij paczkę';
            }
            isOpen = !isOpen;
        });
    }

    // Expose for reuse by other modules (e.g. configurator)
    window.initPackToggle = initPackToggle;

    // Auto-init for static product pages
    var viewer = document.getElementById('pack');
    var btn = document.getElementById('btnTogglePack');
    if (viewer && btn) {
        initPackToggle(viewer, btn);
    }
})();
